export const handleFilePdf = (getFile) => {
  var byteCharacters = atob(getFile);
  var byteNumbers = new Array(byteCharacters.length);
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  var byteArray = new Uint8Array(byteNumbers);
  var blob = new Blob([byteArray], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(blob);
  window.open(fileURL);
  return null
}
